/**
 * Created by vsuthar on 8/23/21
 * File: BreadCrumbs
 * Project: Cloud Management Module ©Palo Alto Networks
 * © Palo Alto Networks
 */

import { Button, TruncateText, Body } from '@panwds/react-ui'
import { CaretRightIcon } from '@panwds/icons'
import { DATA_TEST_BREADCRUMB_LINK, DATA_TEST_RIGHT_ICON } from '../../constants/TestingDataIds'
import { ROOT_NODE_ID } from '../../../tenancy/constants/TenancyConstants'

const LinkComponent = ({ name, onClick, isLast, id, postfix }) => {
  return <div className='tw-flex tw-flex-row tw-items-center'>
    {isLast ? (
      <>
        <Body truncate size='sm' addClassName='tw-ml-1'>
          {name}
        </Body>
        {postfix}
      </>
    ) : (
      <>
        <Button
          data-testid={DATA_TEST_BREADCRUMB_LINK}
          style={{ maxWidth: 150 }} disabled={id === ROOT_NODE_ID}
          appearance={!isLast ? 'clear' : 'tertiary-clear'}
          addClassName={'tw-justify-between tw-align-middle'}
          size={'sm'}
          onClick={onClick}
        >
          <TruncateText>{name}</TruncateText>
        </Button>
        <CaretRightIcon size='xxs' data-testid={DATA_TEST_RIGHT_ICON} className='tw-text-black dark:tw-text-white' />
      </>
    )}
  </div>
}
/**
  @breadcrumbs: Map
  {id: {
    key: 'id',
    value: selectedObj
  }}
 */

const BreadCrumbs = ({ breadcrumbs, onClick, style }) => {
  /**
   * breadcrumbs are coming last first so, Lets reverse it.
   */
  const _breadCrumbs = breadcrumbs?.size ? [...breadcrumbs.entries()].reverse() : []
  return (
    <div style={style} className={'tw-flex tw-flex-row tw-items-center'}>
      {_breadCrumbs.map((each, idx) => {
        const isLast = _breadCrumbs.length - 1 === idx
        const name = (
          <span>
            <span className='tw-inline-block'>{each[1]?.display_name || each[1]?.name}</span>
          </span>
        )
        return <div key={idx}>
          <LinkComponent {...each[1]}
            isLast={isLast}
            name={name}
            key={idx}
            onClick={onClick.bind(this, each[1])}
            postfix={<Body addClassName='tw-inline-block tw-ml-1' appearance='secondary' size='xs'>(TSG ID: {each[0]})</Body>}
          />
        </div>
      })}
    </div>
  )
}

BreadCrumbs.propTypes = {}
export default BreadCrumbs

